import styled from 'styled-components';
import { flexCenter, flexVerticalMiddle } from '../../../utils/style';
import Cell from '../../chat/Grid/Cell';
import Grid from '../../chat/Grid';

export const StyledMessageListWrapper = styled(Cell)`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const StyledMessageListHeader = styled.div`
  flex: 0 0 4.25rem;
  color: ${(props) => props.theme.colors.primary.main};
  border-bottom: 1px solid ${(props) => props.theme.colors.greys.grey20};
  background-color: ${(props) => props.theme.colors.greys.white};
  ${flexCenter}
`;

export const StyledMessageListContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
`;

export const StyledMessageListScrollContent = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow: auto;
  overscroll-behavior: contain;
`;

export const StyledMessageListBottom = styled.div`
  flex-shrink: 0;
`;

export const StyledMessageFormInfo = styled.div`
  background-color: ${(props) => props.theme.colors.info.primary};
  padding: 0.5rem 1rem;
  font-size: ${(props) => props.theme.fontSizes.small.fontSize};
  line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
  word-break: break-word;
`;

export const StyledMessageFormError = styled.div`
  background-color: ${(props) => props.theme.colors.error.lighter};
  color: ${(props) => props.theme.colors.error.primary};
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & {
    .cross-icon {
      flex-shrink: 0;
      margin-left: 0.5rem;
      cursor: pointer;
    }
  }
`;

export const StyledMessageListBottomDisabled = styled.div`
  flex-shrink: 0;
  min-height: 4.125rem;
  padding: 1rem 0;
  font-size: ${(props) => props.theme.fontSizes.h6.fontSize};
  font-weight: bold;
  color: ${(props) => props.theme.colors.greys.grey50};
  ${flexCenter}

  & {
    .disabled-icon {
      margin-right: 1rem;
      flex-shrink: 0;
      color: ${(props) => props.theme.chatDateHeader.bgd};
    }

    .disabled-small-text {
      flex: 1;
      font-size: ${(props) => props.theme.fontSizes.small.fontSize};
      font-weight: normal;
      line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
    }
  }
`;

export const StyledMessageForm = styled.form`
  display: flex;
  background-color: ${(props) => props.theme.colors.greys.white};
  box-shadow: ${(props) => props.theme.shadows.small};
  padding: 0.5rem 0;

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 0.75rem 0;
  }
`;

export const StyledMessageInputTopWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 0.25rem;
  padding-bottom: 0.25rem;
  padding-right: 2rem;
  overflow: auto;

  &:empty {
    display: none;
  }
`;

export const StyledAttachmentPreviewWrapper = styled.div`
  display: flex;
  cursor: pointer;
  margin-right: 3rem;

  & {
    &:last-child {
      margin-right: 0;
    }

    .attachment-preview-container {
      width: 5rem;
    }

    .attachment-preview {
      height: 5rem;
      background-color: ${(props) => props.theme.colors.greys.grey20};
      position: relative;
      pointer-events: none;
      ${flexCenter}

      img {
        object-fit: scale-down;
      }
    }

    .attachment-filename {
      font-size: ${(props) => props.theme.fontSizes.small.fontSize};
      line-height: ${(props) => props.theme.fontSizes.small.lineHeight};
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .attachment-close-icons {
      margin-left: 0.25rem;
      color: ${(props) => props.theme.colors.primary.main};
      position: relative;

      svg {
        position: absolute;

        &:not(:first-child) {
          visibility: hidden;
        }
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    margin-right: 3.5rem;

    & {
      .attachment-preview {
        pointer-events: auto;
      }

      .attachment-filename {
        margin-top: 0.25rem;
      }

      .attachment-close-icons {
        margin-left: 0.5rem;
      }
    }

    &:hover {
      .attachment-preview {
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 1;
        }

        &::after {
          content: '削除';
          font-size: ${(props) => props.theme.fontSizes.text.fontSize};
          font-weight: bold;
          color: ${(props) => props.theme.colors.greys.white};
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 2;
          ${flexCenter}
        }
      }

      .attachment-close-icons {
        svg:first-child {
          visibility: hidden;
        }

        svg:not(:first-child) {
          visibility: visible;
        }
      }
    }
  }
`;

export const StyledSidePanelWrapper = styled(Cell)`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${(props) => props.theme.colors.greys.white};
  border-left: 1px solid ${(props) => props.theme.colors.primary.main};
  position: relative;
`;

export const StyledSidePanelOpenButton = styled.div`
  min-width: 2rem;
  min-height: 2rem;
  padding: 0.625rem 0;
  background-color: ${(props) => props.theme.colors.greys.white};
  border: 1px solid ${(props) => props.theme.colors.primary.main};
  border-right-color: ${(props) => props.theme.colors.greys.white};
  border-radius: 0.25rem 0 0 0.25rem;
  color: ${(props) => props.theme.colors.primary.main};
  position: absolute;
  top: 5.25rem;
  right: 100%;
  z-index: 1;
  cursor: pointer;
  ${flexCenter}
  flex-direction: column;

  & {
    .open-button-text {
      display: none;
      margin-top: 0.5rem;
      font-size: ${(props) => props.theme.fontSizes.text.fontSize};
      font-weight: bold;
      line-height: 1.29;
      width: ${(props) => props.theme.fontSizes.text.fontSize};
      text-align: center;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    & {
      .open-button-text {
        display: block;
      }
    }
  }
`;

export const StyledSidePanelHeader = styled.div`
  flex: 0 0 4.25rem;
  font-size: ${(props) => props.theme.fontSizes.text.fontSize};
  color: ${(props) => props.theme.colors.primary.main};
  font-weight: bold;
  overflow: hidden;
  ${flexCenter}
`;

export const StyledSidePanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 1rem;
  word-break: break-word;
  overscroll-behavior: contain;
`;

export const StyledSidePanelOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: ${(props) => props.theme.modal.wrapperBgd};
  display: none;
`;

export const StyledMessageListGrid = styled(Grid)`
  &.open {
    grid-template-columns: 1fr 13.75rem;

    ${StyledSidePanelOpenButton} svg {
      transform: rotate(180deg);
    }
  }

  ${({ theme }) => theme.mediaQueries.max.md} {
    &.open {
      grid-template-columns: 1fr 0px;

      ${StyledSidePanelWrapper} {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 13.75rem;
        z-index: 2;
      }

      ${StyledSidePanelOverlay} {
        display: block;
      }
    }
  }
`;
